import EmptyState from "ds/components/EmptyState";
import {
  EmptystateBulletListColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";

type StackTasksEmptyProps = {
  hasNoSearchResult: boolean;
  canWrite?: boolean;
};

const StackTasksEmpty = ({ hasNoSearchResult, canWrite }: StackTasksEmptyProps) => {
  return hasNoSearchResult ? (
    <EmptyState
      title="No results"
      icon={EmptystateSearchNoResultsColored}
      caption="Don't give up! Check the spelling or try something less specific."
    />
  ) : (
    <EmptyState
      title="No tasks yet"
      icon={EmptystateBulletListColored}
      caption={
        <>
          Tasks are arbitrary one-off commands that you can run within the context of a fully
          configured and initialized Terraform workspace.{" "}
          {canWrite && (
            <>
              Feel free to give it a try by running something innocent like <code>ls -la</code>.
            </>
          )}
        </>
      }
    />
  );
};

export default StackTasksEmpty;
